export function buildQuickFillCatalogCacheScopeKey(
  cacheScopeKey: string | null | undefined,
  deferUnplacedFamilyCatalog: boolean
): string {
  const base = cacheScopeKey?.trim() || 'unknown-document';
  return `${base}::catalog:${deferUnplacedFamilyCatalog ? 'deferred' : 'complete'}`;
}
